var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMypage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15.3333H7.5C5.01472 15.3333 3 17.3232 3 19.7778V21C3 21.5523 3.44772 22 4 22H20C20.5523 22 21 21.5523 21 21V19.7778C21 17.3232 18.9853 15.3333 16.5 15.3333Z",
    stroke: "#6E6E6E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.8889C14.4853 10.8889 16.5 8.89904 16.5 6.44444C16.5 3.98985 14.4853 2 12 2C9.51472 2 7.5 3.98985 7.5 6.44444C7.5 8.89904 9.51472 10.8889 12 10.8889Z",
    stroke: "#6E6E6E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMypage);
export default __webpack_public_path__ + "static/media/mypage.f752ac811c52932a2174ee8cf80a92df.svg";
export { ForwardRef as ReactComponent };